export default __webpack_public_path__ + "static/media/Tamarin Battle Staff.bd41c701.jpg";